import { __awaiter } from "tslib";
import stringify from 'json-stringify-pretty-compact';
import * as React from 'react';
import { Book, BookOpen, Code, Image, Map } from 'react-feather';
import { withRouter } from 'react-router-dom';
import { mergeConfig, version as VG_VERSION } from 'vega';
import { version as VE_VERSION } from 'vega-embed';
import { version as VL_VERSION } from 'vega-lite';
import { Mode } from '../../../constants/consts';
import './index.css';
class ExportModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            downloadVegaJSON: false,
            includeConfig: true,
            loadingPDF: false,
            errorLoadingPdf: false,
        };
    }
    downloadViz(ext) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = yield this.props.view.toImageURL(ext, 2);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('target', '_blank');
            link.setAttribute('download', `visualization.${ext}`);
            link.dispatchEvent(new MouseEvent('click'));
        });
    }
    openViz(ext) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = yield this.props.view.toImageURL(ext);
            const tab = window.open('about:blank', '_blank');
            tab.document.write(`<title>Chart</title><img src="${url}" />`);
            tab.document.close();
        });
    }
    downloadPDF() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ loadingPDF: true });
            const content = this.props.mode === Mode.Vega ? this.props.vegaSpec : this.props.vegaLiteSpec;
            const body = {
                spec: content,
                baseURL: this.props.baseURL,
            };
            const pdf = yield fetch('https://render-vega.vercel.app', {
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/pdf',
                },
                method: 'post',
                mode: 'cors',
            });
            if (pdf.status !== 200) {
                this.setState({ loadingPDF: false, errorLoadingPdf: true });
                return;
            }
            this.setState({ loadingPDF: false, errorLoadingPdf: false });
            const blob = yield pdf.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('target', '_blank');
            link.setAttribute('download', `visualization.pdf`);
            link.dispatchEvent(new MouseEvent('click'));
        });
    }
    updateIncludeConfig(e) {
        this.setState({
            includeConfig: e.target.checked,
        });
    }
    downloadJSON(event) {
        var _a, _b, _c;
        if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.matches(`input`)) ||
            ((_b = event.target) === null || _b === void 0 ? void 0 : _b.matches(`label`)) ||
            ((_c = event.target) === null || _c === void 0 ? void 0 : _c.matches(`div.type-input-container`))) {
            return;
        }
        let content;
        let filename;
        if (this.props.mode === Mode.Vega) {
            content = this.props.vegaSpec;
            filename = `visualization.vg.json`;
        }
        else {
            content = this.state.downloadVegaJSON ? this.props.vegaSpec : this.props.vegaLiteSpec;
            filename = this.state.downloadVegaJSON ? `visualization.vg.json` : `visualization.vl.json`;
        }
        if (this.state.includeConfig && this.props.config) {
            content = Object.assign({}, content);
            content.config = mergeConfig({}, this.props.config, content.config);
        }
        const blob = new Blob([stringify(content)], {
            type: `application/json`,
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement(`a`);
        link.setAttribute(`href`, url);
        link.setAttribute(`target`, `_blank`);
        link.setAttribute(`download`, filename);
        link.dispatchEvent(new MouseEvent(`click`));
    }
    updateDownloadJSONType(event) {
        this.setState({ downloadVegaJSON: event.currentTarget.value === 'vega' });
    }
    downloadHTML() {
        const { mode, vegaSpec, vegaLiteSpec, config } = this.props;
        let content = mode === Mode.Vega ? vegaSpec : vegaLiteSpec;
        if (config) {
            content = Object.assign({}, content);
            content.config = mergeConfig({}, config, content.config);
        }
        const htmlTemplate = `<!DOCTYPE html>
<html>
<head>
  <script src="https://cdn.jsdelivr.net/npm/vega@${VG_VERSION}"></script>
  <script src="https://cdn.jsdelivr.net/npm/vega-lite@${VL_VERSION}"></script>
  <script src="https://cdn.jsdelivr.net/npm/vega-embed@${VE_VERSION}"></script>
</head>
<body>
  <div id="vis"/>
  <script>
    const spec = ${stringify(content)};
    vegaEmbed("#vis", spec, {mode: "${mode}"}).then(console.log).catch(console.warn);
  </script>
</body>
</html>`;
        const blob = new Blob([htmlTemplate], { type: `text/html;charset=utf-8` });
        const link = document.createElement(`a`);
        link.setAttribute(`href`, window.URL.createObjectURL(blob));
        link.setAttribute(`target`, `_blank`);
        link.setAttribute(`download`, 'visualization.html');
        link.dispatchEvent(new MouseEvent(`click`));
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("h1", null, "Export"),
            React.createElement("div", { className: "exports" },
                React.createElement("div", { className: "export-container" },
                    React.createElement("div", { className: "header-text" },
                        React.createElement(Image, null),
                        React.createElement("span", null, "PNG")),
                    React.createElement("p", null, "PNG is a bitmap image format which is made up of a fixed number of pixels. They have a fixed resolution and cannot be scaled."),
                    React.createElement("button", { onClick: () => this.downloadViz('png') }, "Download ")),
                React.createElement("div", { className: "export-container" },
                    React.createElement("div", { className: "header-text" },
                        React.createElement(Code, null),
                        React.createElement("span", null, "JSON")),
                    React.createElement("p", null, "JSON is a lightweight data-interchange format."),
                    this.props.mode === Mode.VegaLite && (React.createElement("div", { className: "input-container" },
                        React.createElement("label", null,
                            React.createElement("input", { type: "radio", name: "json-type", id: "json-type[vega]", value: "vega", checked: this.state.downloadVegaJSON, onChange: this.updateDownloadJSONType.bind(this) }),
                            ' ',
                            "Compiled Vega"),
                        React.createElement("label", { htmlFor: "json-type[vega-lite]", className: "vl-label" },
                            React.createElement("input", { type: "radio", name: "json-type", id: "json-type[vega-lite]", value: "vega-lite", checked: !this.state.downloadVegaJSON, onChange: this.updateDownloadJSONType.bind(this) }),
                            "Vega-Lite"))),
                    React.createElement("div", { className: "input-container" }, this.state.downloadVegaJSON ? (React.createElement("p", null, "The compiled Vega includes the config and is formatted.")) : (React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", name: "config-include", id: "config-include", value: "config-select", checked: this.state.includeConfig, onChange: this.updateIncludeConfig.bind(this) }),
                            "Include config"),
                        this.state.includeConfig && React.createElement("p", null, "The downloaded spec will be formatted. ")))),
                    React.createElement("button", { onClick: (e) => this.downloadJSON(e) }, "Download")),
                React.createElement("div", { className: "export-container" },
                    React.createElement("div", { className: "header-text" },
                        React.createElement(Map, null),
                        React.createElement("span", null, "SVG")),
                    React.createElement("p", null, "SVG is a vector image format which uses geometric forms to represent different parts as discrete objects and are infinitely scalable."),
                    React.createElement("button", { onClick: () => this.openViz('svg') }, "Open"),
                    React.createElement("button", { onClick: () => this.downloadViz('svg'), className: "export-button download" }, "Download")),
                React.createElement("div", { className: "export-container" },
                    React.createElement("div", { className: "header-text" },
                        React.createElement(Book, null),
                        React.createElement("span", null, "PDF")),
                    React.createElement("p", null,
                        React.createElement("br", null),
                        " PDF is a vector format usually used for documents. This might take a few seconds. Please be patient. Use absolute URLs to ensure that the data is loaded correctly. Your chart is sent to",
                        ' ',
                        React.createElement("a", { href: "https://render-vega.vercel.app/", target: "_blank", rel: "noopener noreferrer" }, "render-vega.vercel.app"),
                        ' ',
                        "for processing."),
                    React.createElement("button", { onClick: () => this.downloadPDF(), disabled: this.state.loadingPDF }, this.state.loadingPDF ? 'Downloading...' : 'Download'),
                    this.state.errorLoadingPdf && (React.createElement("p", { style: { color: 'red' } },
                        "Render service cannot handle external data, please only use external datasets from",
                        ' ',
                        React.createElement("a", { href: "http://vega.github.io/", target: "_blank", rel: "noopener noreferrer" }, "Vega dataset"),
                        "."))),
                React.createElement("div", { className: "export-container" },
                    React.createElement("div", { className: "header-text" },
                        React.createElement(BookOpen, null),
                        React.createElement("span", null, "HTML")),
                    React.createElement("p", null,
                        React.createElement("br", null),
                        " HTML is a document format to be displayed in a browser. Your chart is embedded in the downloaded html file. Use absolute URLs to ensure that the data is loaded correctly."),
                    React.createElement("button", { onClick: () => this.downloadHTML() }, "Download"))),
            React.createElement("div", { className: "user-notes" },
                React.createElement("p", null,
                    React.createElement("strong", null, "Note:"),
                    " To get a PDF, open the SVG which you can print as a PDF from your browser."))));
    }
}
export default withRouter(ExportModal);
